import { useEffect, useState } from "react";
import Product from "../Product/Product";
import "./productList.css";
import { ShimmerPostList } from 'react-shimmer-effects';

const ProductList = ({selectedCategory}) => {

  const [products,setProducts] = useState([]);

  //loader
  const [loading, setLoading] = useState(false);

  //for mobile view
  const [smallScreen,setSmallScreen] = useState(false);

  useEffect(()=>{
    if(window.innerWidth<600){ setSmallScreen(true);

  console.log("smallScreenset",smallScreen);
    
    }
    else {setSmallScreen(false);
  console.log("smallScreenUnset",smallScreen);
    
    }
  },[]);
 
  const category = selectedCategory || "electronics";

  useEffect(() => {
    setLoading(true);
    fetch(`https://fakestoreapi.com/products/category/${category}`)
      .then((response) => response.json())
      .then((json) => {setProducts(json); setLoading(false);})
      .catch((err) => {console.error(err); setLoading(false);});

  }, [category]);

  if(loading){
    return <div className="loading">
    { 
    smallScreen?(
    <ShimmerPostList postStyle="STYLE_SEVEN" size="sm" col={2} row={2} gap={20} />
    ) 
    : 
    <ShimmerPostList postStyle="STYLE_SEVEN" size="sm" col={3} row={2} gap={30} /> 
    }
    </div>
  }

  return<div className="product-list">
  {
    products.map((product) => {
      return <Product key={product.id} product={product} />
    })
  }

</div>
};

export default ProductList;
